import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    absenceReasons: [],
    absences: [],
    absenceApprovals: [],
    users: [],
    sending: false,
    userAbsences: []
  },
  mutations: {
    setAbsences(state, absences) {
      state.absences = absences;
    },
    setAbsenceApprovals(state, absenceApprovals) {
      state.absenceApprovals = absenceApprovals;
    },
    sendState(state, val) {
      state.sending = val;
    },
    setUserAbsences(state, userAbsences) {
      state.userAbsences = userAbsences;
    },
    setAbsenceReasons(state, absenceReasons) {
      state.absenceReasons = absenceReasons;
    }
  },
  actions: {
    fetchAllAbsenceReasons({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/",
            method: "GET"
          })
          .then(({ data }) => {
            commit("setAbsenceReasons", data);
            resolve(data);
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      });
    },
    getAbsenceInfoForMonth({ commit }, users) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/absenceInfoForMonth",
            method: "POST",
            data: users
          })
          .then((resp) => {
            commit("setUserAbsences", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAbsenceInfoForYear(_, users) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/absenceInfoForYear",
            method: "POST",
            data: users
          })
          .then((resp) => {
            //commit("setUserAbsences", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    removeAbsenceLines({ commit }, postObject) {
      commit("sendState", true);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/removeAbsenceFromMainTable",
            method: "POST",
            data: postObject
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    removeAbsenceColumn({ commit }, postObject) {
      commit("sendState", true);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/removeAbsenceFromMainTable",
            method: "POST",
            data: postObject
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAbsences({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/absences/getAbsencesForMonth/${data.userId}/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            commit("setAbsences", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAbsencesForDate(_, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/absences/${data.userId}/getAbsenceForDate/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAbsenceByCode(_, code) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/absences/getAbsenceByCode/${code}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAbsenceApprovals({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/approvals/" + userId,
            method: "GET"
          })
          .then((resp) => {
            commit("setAbsenceApprovals", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendAbsenceApproval({ commit }, absence) {
      commit("sendState", true);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/approvals/",
            method: "POST",
            data: absence
          })
          .then((resp) => {
            commit("sendState", false);

            resolve(resp);
          })
          .catch((err) => {
            commit("sendState", false);
            reject(err);
          });
      });
    },
    saveAbsenceChanges(_, absences) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/saveAbsenceChanges/",
            method: "POST",
            data: absences
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    approveBusinessTrip({ commit }, businessTrip) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/approveBusinessTrip/",
            method: "POST",
            data: businessTrip
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    denyBusinessTrip({ commit }, businessTrip) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences/denyBusinessTrip/",
            method: "POST",
            data: businessTrip
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
  module: {},
  getters: {
    absences: (state) => state.absences,
    absenceApprovals: (state) => state.absenceApprovals,
    userAbsences: (state) => state.userAbsences,
    absenceReasons: (state) => state.absenceReasons
  }
};
